import React from 'react'

interface TimeProps {
  width?: number,
  height?: number,
  fill?: string
}

const Time = ({ height = 24, width = 24, fill= '#FFF' }: TimeProps) => {
  return (
    <svg
      className="drift-default-icon drift-default-icon--Time"
      width={width}
      height={height}
      viewBox="0 0 20 20">
        <path d="M3.55,10.3l.79-.78a.77.77,0,0,1,1.09,1.09L3.3,12.74a.79.79,0,0,1-1.11,0l-2-2.13A.77.77,0,1,1,1.33,9.54l.69.73V10a9,9,0,1,1,3.07,6.77.77.77,0,1,1,1-1.16A7.45,7.45,0,1,0,3.56,10C3.56,10.08,3.56,10.18,3.55,10.3Zm7.72-4.93v4.87h3.34a.77.77,0,0,1,0,1.54H10.5A.76.76,0,0,1,9.73,11V5.37a.77.77,0,0,1,1.54,0Z" fill={fill}/>
    </svg>
  )
}

export default Time

